var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"lbUutcMessage\">\nUnused Tickets\n<i class=\"lbUutcMessage_infoIcon\" lb-tooltip tooltip-content=\"vm.message\" tooltip-inline=\"true\"></i>\n</div>\n";
var id1="components/lbUutcMessage/lbUutcMessage.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbUutcMessage/lbUutcMessage.html
// module id = 1767
// module chunks = 5